import { Card } from '@/components/Card';
import { Flex, Grid } from '@/components/Grid';
import { Illustration } from '@/components/Illustration';
import { Heading } from '@/components/Heading';
import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { type AdItemType } from '@/resource/ad';

type Props = {
  ad: AdItemType;
};

export function ThankYou({ ad }: Props) {
  const singular = ad.type === 'offer' ? 'aanbod' : 'vraag';
  const plural = ad.type === 'offer' ? 'aanbod' : 'vragen';

  return (
    <Grid columns={{ md: [4] }} offsets={{ md: 4 }}>
      <Flex dir="column" gap={4}>
        <Heading balance align="center">
          Bedankt voor het plaatsen van je {singular}
        </Heading>

        <Card padding={4}>
          <Illustration aspectRatio="16-9" illustration="laptop_closeup" />
        </Card>

        <Text balance align="center">
          Dankjewel voor je bericht! Fijn dat je NH Helpt verrijkt met jouw
          bijdrage. We kijken er even naar en daarna komt het online.
        </Text>

        <Flex dir="column" justify="center" align="center">
          <Link underline to={{ type: 'ad_detail', ad }}>
            Naar jouw {singular}
          </Link>
          <Link underline to={{ type: `market_${ad.type}s` }}>
            Naar het overzicht van alle {plural}
          </Link>
        </Flex>
      </Flex>
    </Grid>
  );
}
